export default {
  nav: {
    onlineSms: '온라인 SMS',
    rentNumber: '소프트웨어 개발',
    esim: '복권',
    apiConnection: 'API',
    agent: '실시간 채팅',
    blog: '공유',
    help: '도움말',
    register: '가입',
    login: '로그인'
  },
  header: {
    memberCenter: '멤버 센터',
    logout: '로그아웃',
    logoutSuccess: '로그아웃되었습니다'
  },
  common: {
    user: '사용자',
    chinese: '중국어',
    loading: '로딩 중...',
    noData: '데이터 없음',
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    back: '뒤로',
    submit: '제출',
    search: '검색',
    success: '성공',
    error: '오류',
    warning: '경고',
    info: '정보',
    copySuccess: '복사되었습니다',
    copyFailed: '복사에 실패했습니다',
    operationSuccess: '작업 성공',
    operationFailed: '작업에 실패했습니다',
    networkError: '네트워크 오류, 나중에 다시 시도해 주세요',
    payWith: '결제 수단',
    unit: '',
    yes: '예',
    no: '아니오',
    all: '전체',
    more: '더 보기',
    next: '다음',
    prev: '이전'
  },
  home: {
    title: 'SMS 수신 플랫폼',
    subtitle: '스팸이나 개인정보 유출 없이 소셜 네트워크, 온라인 스토어에 등록하세요.',
    btnGetNumber: '번호 받기',
    btnRent: '렌탈',
    phoneCount: '1000+',
    sectionTitle: 'SMS-MAN — SMS 수신을 위한 전화번호 렌탈',
    sectionDesc: 'SMS-MAN을 통해 200개 이상 국가에서 가상 번호를 렌탈하여 SMS를 받을 수 있습니다. 렌탈 기간: 24시간, 1주, 1개월.',
    sectionDesc2: '많은 온라인 앱에 등록해야 할 때 편리합니다. 번호가 맞지 않으면(SMS를 받지 못하면) 20분 이내에 무료로 취소할 수 있습니다!',
    howItWorks: '사용 방법 확인',
    stepsTitle: '3단계로 가상 번호 렌탈',
    step1Title: '국가 선택',
    step2Title: '렌탈 기간 설정',
    step3Title: '번호 렌탈',
    step1Desc: '인도, 멕시코, 이스라엘',
    step2Desc: '시간, 일, 주, 월',
    step3Desc: '렌탈 기간',
    whyChoose: 'SMS-MAN을 선택하는 이유',
    feature1Title: '일회용 번호 구매 또는 최대 1개월 렌탈',
    feature2Title: 'SMS 수신을 위한 일회용 번호',
    feature2Desc: '가상 번호를 통해 SMS를 받을 서비스를 선택하세요. 어떤 웹사이트나 앱에서든 일회용 SMS 인증 코드를 받을 수 있습니다.',
    feature3Title: '번호 렌탈',
    feature3Desc: '전화번호를 렌탈하고 어떤 웹사이트나 앱에서든 무제한 SMS를 받으세요.',
    usageLimit: '사용 제한',
    usageLimitDesc: '최대 20분',
    usageLimitDesc2: '최대 30일',
    youCanReceive: 'SMS를 받을 수 있습니다',
    youCanReceiveDesc: '구매 시 선택한 1개 웹사이트/앱 무제한',
    youCanReceiveDesc2: '사용 가능한 모든 서비스',
    serviceCount: '200+',
    serviceCount2: '16',
    countryCount: '1000+',
    countryCount2: '모든 사용 가능한 서비스',
    btnRentNow: '지금 렌탈',
    btnRentNumber: '번호 렌탈',
    aboutText: '"SMS-Man"에서는 SMS 수신을 위한 가상 번호를 만들 수 있습니다. 렌탈 번호는 전화번호가 필요한 거의 모든 플랫폼에서 작동합니다.',
    aboutText2: '많은 웹사이트에서 SMS 인증을 요구합니다. 이 서비스는 일반적으로 해외 전화번호에서는 이용할 수 없습니다. SIM 카드를 구매하는 것은 번거롭고 비쌉니다. 약 $0.5-1만 지불하면 됩니다.',
    aboutText3: 'SMS-MAN은 200개 이상의 국가/지역에서 서비스를 제공합니다. 가상 번호를 렌탈하여 어떤 웹사이트나 앱에서든 SMS를 받을 수 있습니다.',
    aboutText4: '"SMS-Man"에서 번호를 렌탈하는 장점:',
    aboutText5: '하나의 가상 번호로 200개 이상의 웹사이트와 앱에 등록할 수 있습니다.',
    aboutText6: '개인 전화번호가 유출되어 스팸을 받을 걱정이 없습니다.',
    aboutText7: '하나의 플랫폼에서 여러 국가의 번호를 관리하고 SMS를 받을 수 있습니다.',
    aboutText8: '전문적인 기술이 필요 없고, 가격도 매우 저렴합니다.',
    aboutText9: '언제 어디서나 온라인으로 전화번호를 렌탈하세요!',
    registerTitle: '가입',
    registerDesc: '개인정보를 입력할 필요가 없습니다, 3단계면 충분',
    regStep1: '웹사이트에서 이메일 입력',
    regStep1Desc: '이메일 주소를 입력하고 비밀번호를 만드세요.',
    regStep2: '메일박스에서 이메일 확인',
    regStep2Desc: '입력한 이메일로 확인 메일을 보냈습니다. 이메일을 열고 확인 링크를 클릭하세요.',
    regStep3: '축하합니다! 가입 완료',
    regStep3Desc: '이제 SMS-MAN의 모든 서비스에 로그인하여 이용할 수 있습니다.',
    onlineServiceTitle: '편리한 온라인 SMS 수신 서비스',
    joinTelegram: '온라인 채팅 참여',
    joinTelegramDesc: '텔레그램 그룹에 참여하여 최신 정보를 받으세요',
    telegramBot: '텔레그램 봇',
    telegramBotDesc: '텔레그램 봇으로 SMS 수신',
    userGroup: '사용자 그룹',
    userGroupDesc: '사용자 그룹에 참여하여 도움을 받으세요',
    desktopApp: '데스크톱 애플리케이션',
    desktopAppDesc: '데스크톱 애플리케이션 다운로드',
    btnJoin: '참여',
    btnConnect: '연결',
    btnDownload: '다운로드',
    professionalTitle: '전문가를 위한 솔루션',
    professionalDesc: 'SMS-MAN은 일반 사용자뿐만 아니라 대량의 계정 등록과 제한된 리소스 접근이 필요한 전문가를 위한 도구도 제공합니다.',
    apiConnect: 'API 연결',
    apiConnectDesc: '배치 SMS 수신 및 발신, 작업 자동화',
    readMore: '더 읽기',
    faqTitle: '자주 묻는 질문',
    faq1: 'SMS 플랫폼 서비스란? 어떻게 작동하나요?',
    faq2: 'SMS-MAN이란?',
    faq3: 'SMS 수신을 위한 일회용 SIM 카드가 필요한가요?',
    faq4: 'SMS-MAN에서 개인정보가 안전한가요?',
    faq5: 'SMS 수신 성공을 확인하는 방법은?',
    faq6: 'SMS 플랫폼이 정말 안전한가요?',
    faq7: 'SMS 수신을 위해 SMS-Man을 선택하는 이유는?',
    footer: {
      smsPlatform: 'SMS 플랫폼',
      rentNumber: '번호 렌탈',
      apiConnection: 'API',
      referral: '추천',
      partnership: '파트너십',
      partners: '파트너',
      blog: '공유',
      help: '도움말',
      privacyPolicy: '개인정보 처리방침',
      termsOfUse: '이용약관',
      paymentRefund: '결제 및 환불',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  login: {
    title: '로그인',
    email: '이메일',
    password: '비밀번호',
    emailPlaceholder: '이메일 입력',
    passwordPlaceholder: '비밀번호 입력',
    forgotPassword: '비밀번호를 잊으셨나요?',
    noAccount: '계정이 없으신가요?',
    register: '가입',
    socialLogin: '소셜 플랫폼으로 로그인',
    btnLogin: '로그인',
    captchaSuccess: '성공!',
    loginFailed: '로그인에 실패했습니다'
  },
  register: {
      title: '회원가입',
      email: '이메일 입력',
      codePlaceholder: '인증코드 입력',
      sendCode: '코드 받기',
      sending: '전송 중...',
      codeSent: '코드가 전송되었습니다. 이메일을 확인하세요',
      password: '비밀번호 생성',
      confirmPassword: '비밀번호 확인',
      agreeTerms: '가입 시 동의하는 것으로 간주됩니다',
      terms: '이용약관',
      hasAccount: '이미 계정이 있으신가요?',
      login: '로그인',
      socialLogin: '또는 소셜 계정으로 로그인',
      btnRegister: '회원가입',
      registering: '가입 중...',
      captchaSuccess: '성공!',
      passwordMismatch: '비밀번호가 일치하지 않습니다',
      registerFailed: '회원가입에 실패했습니다',
      codeExpired: '코드가 만료되었습니다. 다시 요청하세요',
      codeError: '인증코드가 올바르지 않습니다'
    },
  member: {
    sidebar: {
      receiveSms: 'SMS 수신',
      premiumSms: '프리미엄 SMS',
      rentNumber: '번호 렌탈',
      esim: 'eSIM',
      proxyMan: 'Proxy Man',
      recharge: '충전',
      loyalty: '로열티',
      earn: '적립',
      partnership: '파트너십',
      api: 'API',
      instructions: '사용법',
      feedback: '피드백',
      help: '도움말',
      chatGroup: '실시간 채팅',
      chatManage: '채팅 관리',
      receptionRecords: '수신 기록',
      chatPlan: '채팅 플랜',
	  chatSettings: '채팅 설정',
      lotteryGroup: '복권',
      lotteryBets: '베팅 기록'
    },
    header: {
      desktopClient: '데스크톱 클라이언트',
      desktopClientDesc: '컴퓨터에서 직접 SMS 수신',
      telegramBot: '텔레그램 봇',
      telegramBotDesc: '텔레그램에서 직접 SMS 수신',
      try: '사용',
      connect: '연결',
      balance: '잔액',
      recharge: '충전',
      language: '언어'
    },
    avatarMenu: {
      settings: '설정',
      profile: '프로필 보기',
      logout: '로그아웃'
    },
    receiveSms: {
      title: 'SMS 수신',
      selectService: '서비스 선택',
      searchService: '서비스로 검색',
      selectCountry: '국가 선택',
      searchCountry: '국가로 검색',
      sort: '정렬',
      buySms: 'SMS 구매',
      doubleSms: '이중 SMS',
      btnBuySms: 'SMS 구매'
    },
    premiumSms: {
      title: '프리미엄 SMS',
      selectService: '서비스 선택',
      searchService: '서비스로 검색',
      selectCountry: '국가 선택',
      searchCountry: '국가로 검색',
      sort: '정렬',
      buySms: 'SMS 구매',
      doubleSms: '이중 SMS',
      btnBuySms: 'SMS 구매'
    },
    rentNumber: {
      title: '번호 렌탈',
      subtitle: 'SMS 수신 전용',
      wholeNumber: '전체 번호',
      byService: '서비스별',
      selectCountry: '1. 국가 선택',
      search: '검색',
      setDuration: '2. 기간 설정',
      hour: '시간',
      day: '일',
      week: '주',
      month: '월',
      rentNumber: '3. 번호 렌탈',
      cost: '비용',
      btnRent: '렌탈',
      rentDesc: '번호와 렌탈 기간에 대해 결제합니다. 선택한 기간 동안 무제한 SMS를 받을 수 있습니다. 구매 후 취소, 환불, 조기 종료는 불가능합니다.',
      premiumTitle: '프리미엄 번호',
      premiumDesc: '더 높은 전달율과 더 강력한 안정성을 가진 고품질 번호 이용',
      btnPremium: '프리미엄 받기'
    },
    esim: {
      title: 'eSIM',
      selectCountry: '1. 국가/지역 선택',
      searchCountry: '국가 또는 지역 검색',
      all: '전체',
      mixed: '혼합',
      showAll: '모두 보기',
      selectPlan: '2. 플랜 선택',
      esimInfo: 'eSIM은 결제 후 즉시 활성화됩니다. 설치 QR 코드가 계정에 제공됩니다.',
      phoneSupport: '사용 중인 휴대폰이 eSIM을 지원하나요?',
      phoneSupportDesc: '*#06#을 눌러 EID가 표시되면 eSIM을 지원합니다.',
      howToConfig: 'eSIM으로 모바일 데이터를 설정하는 방법',
      selectType: '3. eSIM 유형 선택',
      allType: '전체',
      dataOnly: '데이터만',
      dataAndCall: '데이터 + 통화',
      btnRecharge: '충전'
    },
    recharge: {
      title: '잔액 충전',
      payMethod: '결제 방법',
      usdtDesc: 'USDT TRC-20으로 충전, 관리자 확인 후到账',
      onlyUsdt: 'USDT만 지원',
      fillAmount: '충전 금액',
      otherAmount: '직접 입력',
      btnPay: '충전하기',
      submitting: '전송 중...',
      payDesc: '주문 생성 후 USDT 주소와 QR코드가 표시됩니다',
      invalidAmount: '유효한 금액을 입력해 주세요 (최소 $1)',
      rechargeFailed: '충전에 실패했습니다',
      rechargeFailedRetry: '충전에 실패했습니다, 다시 시도해 주세요',
      historyTitle: '충전 기록',
      thOrderNo: '주문번호',
      thAmount: '금액',
      thStatus: '상태',
      thTime: '시간',
      statusPending: '확인 대기',
      statusPaid: '到账 완료',
      statusCancelled: '취소됨',
      scanToPay: 'QR코드로 결제',
      payAmount: '결제 금액',
      usdtAddress: 'USDT TRC-20 수신 주소',
      copy: '복사',
      copied: '복사됨',
      orderNo: '주문번호',
      waitingConfirm: '관리자 확인을 기다리고 있습니다. 결제 후 자동 새로고침됩니다',
      paySuccess: '충전到账',
      paySuccessDesc: '충전이 성공적으로到账되었습니다'
    },
    feedback: {
      title: '문의하기',
      name: '이름',
      email: '이메일',
      question: '질문',
      btnSend: '전송',
      captchaSuccess: '성공!',
      support247: '24시간 연중무휴 지원',
      responseTime: '평균 응답 시간 약 15분',
      weekendWork: '주말도 평상시와 같이 지원',
      chatSupport: '채팅 지원',
      youtube: 'YouTube'
    },
    partnership: {
      title: 'SIM 카드로 신뢰할 수 있는 서비스에서 수익 창출',
      desc1: 'SMS 수신이 가능한 전화번호(SIM 카드)가 있으시다면, 이 페이지가 적합합니다.',
      desc2: 'SMS-Man에서 SIM 카드로 수익을 시작하세요!',
      whatTogether: '함께 할 수 있는 것',
      whatTogetherDesc: 'SMS-Man은 온라인 SMS 수신을 위한 국제 플랫폼입니다. 현재 20만 명의 활성 사용자와 하루 1억 건 이상의 SMS 요청이 있습니다.',
      whatTogetherDesc2: '그래도 부족합니다: 고객의 수요가 빠르게 증가하고 있습니다. 그래서 여러분을 찾고 있습니다.',
      howContact: 'SMS-Man에 연락하는 방법은?',
      restApi: 'REST API',
      restApiDesc: 'API 파일과 직접 결제 계정을 제공해 주세요. 당사 시스템에 통합합니다.',
      gsmGoip: 'GSM/GoIP',
      gsmGoipDesc1: 'GSM/GoIP 장비를 보유',
      gsmGoipDesc2: '전용 소프트웨어로 시스템에 연결',
      gsmGoipDesc3: '전용 대시보드에서 통계 추적',
      gsmGoipDesc4: '수익은 SIM 카드의 국가에 따라 다릅니다',
      apiLink: 'API 링크',
      apiLinkDesc1: '예: 이 형식의 번호가 있는 경우:',
      apiLinkDesc2: '조건에 따라 번호 구매'
    },
    instructions: {
      title: 'SMS-MAN으로 Facebook 가입',
      step1: '1단계. 번호 받기.',
      step1Desc: '일회용',
      receiveSms: 'SMS 수신',
      or: '또는',
      rentNumber: '번호 렌탈',
      step2: '2단계. 받은 번호를 복사.',
      step2Desc: '옆 아이콘을 클릭하거나 번호를 선택하고 Ctrl+C로 복사.',
      step3: '3단계. Facebook 가입 정보 입력.',
      step3Desc: 'facebook.com에 접속하여 "새 계정 만들기"를 클릭.'
    },
    loyalty: { title: '로열티 프로그램' },
    earn: { title: '적립' },
    api: { title: 'API 문서' },
    help: { title: '도움말 센터' },
    lotteryBets: {
      title: '베팅 기록',
      allTypes: '모든 유형',
      allResults: '모든 결과',
      win: '승',
      lose: '패',
      pending: '대기 중',
      searchPeriod: '기간 검색...',
      totalBets: '총 베팅',
      totalWin: '승',
      totalLose: '패',
      totalPending: '대기 중',
      totalProfit: '총 손익',
      period: '기간',
      lotteryType: '유형',
      playType: '플레이',
      betContent: '베팅 내용',
      betAmount: '금액',
      odds: '배당률',
      drawNumbers: '추첨 번호',
      result: '결과',
      profit: '손익',
      time: '시간',
      totalRecords: '{0} 건',
      prevPage: '이전',
      nextPage: '다음'
    },
    profile: {
      title: '프로필',
      pageDesc: '계정 상세 정보 보기',
      userId: '사용자 ID',
      balance: '잔액',
      registerTime: '가입 일시',
      lastLogin: '마지막 로그인',
      accountStatus: '계정 상태',
      langSetting: '언어',
      statusActive: '활성',
      statusInactive: '비활성',
      apiInfo: 'API 정보',
      apiKey: 'API 키',
      notGenerated: '미생성',
      copy: '복사',
      usageStats: '사용 통계',
      smsOrders: 'SMS 주문',
      rechargeCount: '충전 횟수',
      totalSpent: '총 사용액',
      chatSessions: '채팅 세션'
    },
    settings: {
      title: '설정',
      pageDesc: '계정 및 보안 관리',
      changePassword: '비밀번호 변경',
      currentPassword: '현재 비밀번호',
      currentPasswordPh: '현재 비밀번호 입력',
      newPassword: '새 비밀번호',
      newPasswordPh: '새 비밀번호 입력 (6자 이상)',
      confirmNewPassword: '새 비밀번호 확인',
      confirmNewPasswordPh: '새 비밀번호 재입력',
      saving: '저장 중...',
      saveChanges: '변경 저장',
      changeEmail: '이메일 변경',
      currentEmail: '현재 이메일',
      newEmail: '새 이메일',
      newEmailPh: '새 이메일 입력',
      accountSecurity: '계정 보안',
      apiKey: 'API 키',
      notGenerated: '미생성'
    },
	chatSettings: {
	  title: '채팅 설정',
	  avatar: '채팅 아바타',
	  avatarTip: '권장 크기: 200x200, JPG/PNG 지원, 최대 5MB',
	  channelName: '채팅 이름',
	  channelNamePlaceholder: '채팅 표시 이름을 입력하세요',
	  welcomeMsg: '기본 환영 메시지',
	  welcomeMsgPlaceholder: '방문자가 채팅에 입장할 때 자동 전송되는 환영 메시지',
	  save: '설정 저장',
	  saving: '저장 중...',
	  saveSuccess: '저장되었습니다',
	  saveFailed: '저장에 실패했습니다'
	},
    chatPlan: {
      title: '채팅 플랜',
      currentPlan: '현재 플랜',
      perMonth: '/월',
      seats: '에이전트',
      seatsUnit: '',
      maxSessions: '최대 세션',
      expiryTime: '만료일',
      daysLeft: '(남은 일수 {0}일)',
      autoRenew: '자동 갱신',
      btnRenew: '지금 갱신',
      btnUpgrade: '업그레이드',
      plansTitle: '플랜',
      recommended: '추천',
      current: '현재',
      selectPlan: '플랜 선택',
      renewalTitle: '갱신 이력',
      thOrderId: '주문 ID',
      thPlan: '플랜',
      thAmount: '금액',
      thPayment: '결제',
      thDuration: '기간',
      thExpiry: '만료일',
      thStatus: '상태',
      renewModalTitle: '플랜 갱신',
      month: '{0} 개월',
      discount10: '10% 할인',
      discount7: '30% 할인',
      confirmRenew: '갱신 확인',
      renewSuccess: '갱신 완료! {0} 개월 연장',
	  kaiqiok: '성공적으로 활성화되었습니다',
	  guanbiok: '성공적으로 비활성화되었습니다',
      renewFailed: '갱신에 실패했습니다',
      retryLater: '다시 시도해 주세요',
      switchSuccess: '{0}(으)로 전환되었습니다',
      switchFailed: '전환에 실패했습니다'
    },
    chatManage: {
      sessionList: '세션',
      sessionCount: '{0} 개 세션',
      searchVisitor: '방문자 검색...',
      online: '온라인',
      offline: '오프라인',
      source: '소스:',
      btnTransfer: '전송',
      btnEndSession: '세션 종료',
      btnEnd: '종료',
      inputPlaceholder: '메시지 입력...',
      send: '전송',
      me: '나',
      selectSession: '세션을 선택하여 채팅 시작',
      emoji: '이모지',
      file: '파일'
    },
    receptionRecords: {
      title: '수신 기록',
      allStatus: '모든 상태',
      completed: '완료',
      ongoing: '진행 중',
      missed: '부재',
      searchVisitor: '방문자 이름 검색...',
      visitor: '방문자',
      source: '소스',
      agent: '에이전트',
      startTime: '시작 시간',
      endTime: '종료 시간',
      messages: '메시지',
      satisfaction: '만족도',
      status: '상태',
      action: '작업',
      view: '보기',
      notRated: '미평가',
      totalRecords: '{0} 건',
      prevPage: '이전',
      nextPage: '다음',
      detailTitle: '세션 상세',
      visitorEmail: '방문자 이메일:',
      sourceLabel: '소스:',
      agentLabel: '에이전트:',
      durationLabel: '소요 시간:',
      minute: '분'
    },
    agentManage: {
      title: '상담원 관리',
      addAgent: '상담원 추가',
      agent: '상담원',
      account: '계정',
      status: '상태',
      currentSessions: '대응 중',
      lastOnline: '마지막 로그인',
      action: '작업',
      online: '온라인',
      offline: '오프라인',
      enable: '활성화',
      disable: '비활성화',
      edit: '편집',
      delete: '삭제',
      loading: '로딩 중...',
      empty: '상담원이 없습니다. 오른쪽 위 추가를 클릭하세요',
      addTitle: '상담원 추가',
      editTitle: '상담원 편집',
      nameLabel: '상담원 이름',
      namePlaceholder: '예: 지원 장',
      accountLabel: '로그인 계정',
      accountPlaceholder: '예: kefu1',
      passwordLabel: '로그인 비밀번호',
      passwordPlaceholder: '6자 이상',
      resetPasswordLabel: '비밀번호 재설정 (비워두면 변경 안 함)',
      resetPasswordPlaceholder: '비워두면 현재 비밀번호 유지',
      statusLabel: '상태',
      cancel: '취소',
      saving: '저장 중...',
      save: '저장',
      nameRequired: '상담원 이름을 입력하세요',
      passwordMin: '비밀번호는 6자 이상이어야 합니다',
      accountRequired: '로그인 계정을 입력하세요',
      saveSuccess: '저장되었습니다',
      saveFailed: '저장에 실패했습니다',
      opFailed: '작업에 실패했습니다',
      networkError: '네트워크 오류, 나중에 다시 시도해 주세요',
      deleteSuccess: '삭제되었습니다',
      deleteFailed: '삭제에 실패했습니다',
      toggleConfirm: '상담원 "{1}"을(를) {0}하시겠습니까?',
      deleteConfirm: '상담원 "{0}"을(를) 삭제하시겠습니까? 되돌릴 수 없습니다!'
    }
  },
  help: {
    title: '도움말 페이지',
    subtitle: 'SMS-Man 서비스 사용 방법과 가장 흔한 질문에 대한 답변',
    popularQuestions: '인기 질문',
    q1: '가입 후 SMS를 기다리는 시간은?',
    q1a: 'SMS 대기 시간은 5분 이내입니다. 5분 이내에 SMS를 받지 못하면 번호를 취소하고 다른 번호를 구매하세요.',
    q2: 'SMS는 몇 건 받을 수 있나요?',
    q3: '최소 충전 금액은 얼마인가요?',
    q4: '목록에 없는 서비스でも SMS를 받을 수 있나요?',
    q5: 'SMS를 받지 못했을 때 어떻게 해야 하나요?',
    q6: '"서비스를 일시적으로 사용할 수 없습니다" 오류란?',
    q7: 'API 키는 어디에서 확인할 수 있나요?',
    q8: '어떻게 저희와 수익을 낼 수 있나요?',
    serviceGuide: '서비스 가이드',
    serviceGuideTitle: '온라인 가입 방법은?',
    serviceGuideDesc: '계정 가입, 전화번호 입력, 국가 선택, 서비스 선택, 구매 클릭, SMS 대기.',
    howToRent: '서비스용 렌탈 방법은?',
    howToRentDesc: '서비스 선택, 국가 선택, 렌탈 기간 선택, 렌탈 클릭.',
    howToBuy: '일회용 SMS를 구매하려면?',
    howToBuyDesc: '서비스 선택, 국가 선택, SMS 구매 클릭.',
    howToUseNumber: '렌탈 번호를 사용하는 방법은?',
    howToUseNumberDesc: '주문 페이지에서 번호를 복사, 대상 웹사이트에 입력, SMS 대기.',
    footer: {
      smsPlatform: 'SMS 플랫폼',
      rentNumber: '번호 렌탈',
      apiConnection: 'API',
      referral: '추천',
      partnership: '파트너십',
      partners: '파트너',
      blog: '공유',
      help: '도움말',
      privacyPolicy: '개인정보 처리방침',
      termsOfUse: '이용약관',
      paymentRefund: '결제 및 환불',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  blog: {
    title: '아티클 센터',
    recentPosts: '최근 게시물',
    archives: '아카이브',
    readMore: '더 읽기',
    comments: '조회수',
    category: '카테고리',
    currentCategory: '현재 카테고리:',
    clearFilter: '✕ 필터 초기화',
    allCategories: '모든 카테고리',
    articleCategories: '카테고리'
  },
  articleDetail: {
    loading: '로딩 중...',
    notFound: '아티클을 찾을 수 없습니다',
    backToList: '← 아티클 목록으로 돌아가기',
    home: '홈',
    blog: '공유',
    views: '조회수',
    share: '공유:',
    relatedArticles: '관련 아티클'
  },
  homeApi: {
    title: '개발자용',
    subtitle: 'SMS-Man과 서비스를 연결하고 자동으로 번호를 구매하기 위한 API 문서',
    legacyApi: '레거시 API',
    apiV2: 'API 2.0',
    miniApi: 'Mini API',
    apiDesc: 'API 인터페이스를 통해 SMS-Man에서 자동으로 SMS를 구매하고 받을 수 있습니다. 서비스는 자동으로 동기화됩니다. 자동 수신을 위해 API를 리셋하세요. API 사용에는 API 키도 필요합니다. 프로필 페이지에서 확인할 수 있습니다. 모든 API 요청은 GET 또는 POST 방식입니다. 모든 요청에 token 파라미터와 API 키를 포함해야 합니다.',
    getBalance: '잔액 조회',
    getBalanceDesc: '현재 계정 잔액 조회',
    params: '파라미터',
    field: '필드',
    type: '유형',
    required: '필수',
    value: '값',
    result: '결과',
    possibleErrors: '가능한 오류',
    rateLimit: '속도 제한',
    getNumber: '번호 받기',
    getNumberDesc: '지정 국가의 번호를 받기, country_id 지정',
    getSms: 'SMS 받기',
    getSmsDesc: '지정 주문의 SMS 받기',
    setStatus: '상태 설정',
    setStatusDesc: '주문 상태 변경',
    getCountries: '국가 목록 조회',
    getCountriesDesc: '사용 가능한 모든 국가 조회',
    getServices: '서비스 목록 조회',
    getServicesDesc: '사용 가능한 모든 서비스 조회'
  },
  onlineSms: {
    hero: {
      title: '온라인 SMS 인증 플랫폼',
      desc: '스팸이나 개인정보 유출 없이 소셜 네트워크, 온라인 스토어에 등록하세요.',
      viewNumbers: '번호 보기',
      receiveCode: '코드 받기'
    },
    countries: {
      title: '국가/지역 선택',
      subtitle: '200개 이상 국가에서 SMS 인증용 가상 번호 선택',
      services: '서비스',
      select: '선택'
    },
    services: {
      title: '오늘의 인기 서비스',
      buy: '구매'
    },
    howItWorks: {
      title: '3단계로 가상 번호 렌탈',
      subtitle: '사용 방법 확인',
      step1Title: '국가 선택',
      step1Desc: '200개 이상 옵션 중 가상 번호의 국가 선택',
      step2Title: '서비스 선택',
      step2Desc: 'SMS를 받고 싶은 앱 또는 서비스 선택',
      step3Title: 'SMS 받기',
      step3Desc: '가상 번호를 받아 온라인으로 인증 코드 수신'
    },
    features: {
      fastTitle: '빠른 인증',
      fastDesc: '몇 초 만에 인증 코드 받기, 대기 시간 없음',
      safeTitle: '개인정보 보호',
      safeDesc: '가상 번호로 개인정보 보호',
      globalTitle: '글로벌 커버리지',
      globalDesc: '200개 이상 국가에서 서비스 지원'
    },
    cta: {
      title: '지금 가입하고 인증 시작',
      desc: '가입 시 무료 크레딧을 받고 가상 번호 서비스를 체험하세요',
      register: '무료 가입'
    },
    faq: {
      title: '자주 묻는 질문',
      q1: '온라인 SMS 인증이란?',
      a1: '온라인 SMS 인증은 가상 번호를 사용하여 SMS 인증 코드를 받는 서비스로, 실제 전화번호를 사용하지 않습니다.',
      q2: '번호는 얼마나 오래 사용할 수 있나요?',
      a2: '서비스에 따라 20분에서 30일까지 사용할 수 있습니다.',
      q3: '개인정보는 어떻게 보호되나요?',
      a3: '모든 번호는 가상이며 사용 후 폐기되어 실제 전화번호가 노출되지 않습니다.'
    }
  },
  esim: {
    hero: {
      title: 'eSIM 온라인 구매',
      desc: '글로벌 모바일 데이터를 즉시 이용하세요. QR 코드로 몇 초 만에 eSIM을 활성화하고 비싼 로밍 요금에 작별하세요.',
      learnMore: '자세히',
      countries: '국가',
      network: '네트워크',
      activation: '활성화'
    },
    howItWorks: {
      title: '3가지 간단한 단계로 연결',
      step1Title: '플랜 선택',
      step1Desc: '필요한 국가/지역과 데이터 플랜 선택',
      step2Title: '결제 & QR 코드 받기',
      step2Desc: '결제 후 eSIM 활성화 QR 코드를 받습니다',
      step3Title: '스캔하고 온라인',
      step3Desc: '휴대폰 설정에서 QR 코드를 스캔하여 eSIM 활성화'
    },
    whyEsim: {
      title: 'eSIM의 장점',
      subtitle: '해외에서 연결되는 스마트한 방법',
      f1Title: '로밍 요금 없음',
      f1Desc: '현지 모바일 네트워크를 사용하여 비싼 국제 로밍 요금을 피하세요',
      f2Title: '즉시 활성화',
      f2Desc: 'QR 코드를 스캔하여 활성화, 물리적 SIM 카드 대기 시간 없음',
      f3Title: '메인 SIM 유지',
      f3Desc: 'eSIM을 데이터용으로 사용하면서 메인 번호를 계속 사용'
    },
    cta: {
      title: '로밍 요금 없이 여행할 준비가 되셨나요?',
      desc: '몇 분 만에 eSIM을 활성화하고 전 세계에서 연결하세요'
    },
    comparison: {
      title: 'eSIM vs. 현지 SIM 카드',
      r1: '여행 전 설정',
      r2: '즉시 활성화',
      r3: '카드 교체 없음',
      r4: '메인 번호 유지',
      r5: '고정된 예측 가능한 가격',
      r6: '이메일만으로 가입',
      r7: '암호화폐 지원'
    },
    plus: {
      title: 'eSIM plus SMS-MAN의 기존 기능',
      desc: '데이터 플랜과 가상 번호, SMS 인증을 하나의 계정에서'
    },
    faq: {
      title: 'eSIM에 관한 질문',
      q1: 'eSIM이란? 어떻게 작동하나요?',
      a1: 'eSIM은 물리적 카드 없이 모바일 데이터를 활성화하는 내장 SIM입니다. QR 코드를 스캔하기만 하면 활성화됩니다.',
      q2: '어떤 기기가 SMS-MAN eSIM을 지원하나요?',
      a2: '대부분의 최신 스마트폰이 eSIM을 지원합니다. iPhone XS 이후, Samsung Galaxy S20 이후.',
      q3: '활성화는 얼마나 빠른가요?',
      a3: '보통 몇 초면 충분합니다. QR 코드를 스캔하고 바로 사용하세요.',
      q4: 'eSIM이 메인 번호를 대체하나요?',
      a4: '아니요, eSIM은 데이터 전용입니다. 메인 번호는 그대로 유지됩니다.',
      q5: '나중에 데이터를 충전하거나 추가 구매할 수 있나요?',
      a5: '네, 계정에서 언제든지 추가 데이터 팩을 구매할 수 있습니다.'
    }
  },
  agent: {
    hero: {
      title: 'SMS-MAN 에이전트 되기',
      desc: 'SMS-MAN 서비스를 홍보하여 커미션을 받고 수동적 소득을 구축하세요.',
      becomeAgent: '에이전트 되기',
      learnMore: '자세히'
    },
    benefits: {
      title: '에이전트 혜택',
      subtitle: 'SMS-MAN 에이전트가 되는 이유',
      b1Title: '높은 커미션',
      b1Desc: '최대 20% 추천 커미션 수령',
      b2Title: '수동적 소득',
      b2Desc: '추천 사용자가 지출을続ける 한 커미션을 받습니다',
      b3Title: '전용 지원',
      b3Desc: '빠른 문제 해결을 위한 전용 에이전트 계정 매니저',
      b4Title: '글로벌 마켓',
      b4Desc: '지리적 제한 없이 전 세계 사용자에게 홍보'
    },
    howItWorks: {
      title: '시작 방법',
      step1Title: '계정 가입',
      step1Desc: 'SMS-MAN 계정을 만들고 에이전트 신청',
      step2Title: '추천 링크 받기',
      step2Desc: '고유 추천 링크와 마케팅 자료를 받습니다',
      step3Title: '커미션 받기',
      step3Desc: '사용자가 링크를 통해 가입하고 지출하면 커미션을 받습니다'
    },
    commission: {
      title: '커미션 레벨',
      l1Name: '주니어 에이전트',
      l1Desc: '월 1-50명 추천 사용자',
      l2Name: '미드 에이전트',
      l2Desc: '월 51-200명 추천 사용자',
      l3Name: '시니어 에이전트',
      l3Desc: '월 200명 이상 추천 사용자'
    },
    features: {
      title: '에이전트 도구',
      f1Title: '대시보드',
      f1Desc: '추천 데이터와 커미션 수익을 실시간으로 확인',
      f2Title: '추천 링크',
      f2Desc: '정확한 전환 추적이 가능한 고유 추천 링크',
      f3Title: '빠른 출금',
      f3Desc: '언제든지 여러 결제 방법으로 커미션 출금',
      f4Title: '전용 지원',
      f4Desc: '우선 처리되는 전용 에이전트 지원 채널'
    },
    cta: {
      title: '시작할 준비가 되셨나요?',
      desc: '지금 가입하여 SMS-MAN 에이전트가 되고 수동적 소득의 여정을 시작하세요',
      joinNow: '지금 참여'
    }
  },
  softwareDev: {
    heroTitle: '전문 소프트웨어 개발 서비스',
    heroDesc: '요구사항 분석부터 납품까지, 풀스택 맞춤형 개발 솔루션을 제공합니다. 웹 애플리케이션, 모바일 앱, 관리 시스템, API 개발 등.',
    btnViewCases: '사례 보기',
    btnContact: '문의하기',
    servicesTitle: '서비스',
    servicesSubtitle: '다양한 비즈니스 요구를 충족하는 종합적인 소프트웨어 개발 서비스',
    service1Title: '웹 애플리케이션 개발',
    service1Desc: '기업 사이트, 이커머스 플랫폼, SaaS 시스템, 관리 대시보드의 풀스택 개발',
    service2Title: '모바일 앱 개발',
    service2Desc: '네이티브 iOS/Android 앱 및 React Native/Flutter를 사용한 크로스 플랫폼 개발',
    service3Title: 'API 개발',
    service3Desc: 'RESTful API, WebSocket 실시간 통신, 서드파티 시스템 통합',
    service4Title: '자동화 시스템',
    service4Desc: '데이터 수집, 자동화 스크립트, 예약 작업, 비즈니스 프로세스 자동화',
    service5Title: '게임/엔터테인먼트 시스템',
    service5Desc: '카드 게임, 복권 시스템, 인스턴트 메시징, 실시간 인터랙티브 플랫폼',
    service6Title: '클라우드 배포',
    service6Desc: '서버 배포, CI/CD 파이프라인, Docker 컨테이너화, 성능 최적화',
    techStackTitle: '기술 스택',
    casesTitle: '프로젝트 사례',
    casesSubtitle: '납품된 프로젝트 쇼케이스',
    projectShare: '공유',
    processTitle: '개발 프로세스',
    process1Title: '요구사항 논의',
    process1Desc: '프로젝트 요구사항을 깊이 이해하고 범위와 기술 접근 방식 정의',
    process2Title: '솔루션 설계',
    process2Desc: '상세한 기술 아키텍처, 데이터베이스 설계, UI 프로토타입',
    process3Title: '개발',
    process3Desc: '정기적인 데모와 진행 상황 공유를 가진 애자일 개발',
    process4Title: '테스트 및 최적화',
    process4Desc: '기능, 성능, 보안의 포괄적 테스트',
    process5Title: '배포',
    process5Desc: '서버 배포, 도메인 설정, SSL 인증서, 모니터링',
    process6Title: '유지보수 및 지원',
    process6Desc: '시스템 안정성을 보장하기 위한 지속적인 기술 지원 및 버그 수정',
    stats1Label: '납품 프로젝트',
    stats2Label: '만족 클라이언트',
    stats3Label: '경력 연수',
    stats4Label: '클라이언트 만족도',
    contactTitle: '프로젝트가 있으신가요?',
    contactDesc: '아이디어를 알려주세요. 전문적인 개발 솔루션과 견적을 제공합니다',
    contactOnline: '온라인 지원',
    contactBtn: '지금 상담'
  },
  lotteryPage: {
    heroTitle: '라이브 복권 추첨 센터',
    heroDesc: '다양한 복권의 즉시 추첨, 실시간 데이터 동기화, 공정하고 투명',
    statLottery: '복권 종류',
    statNonStop: '끊임없는 추첨',
    statSync: '실시간 동기화',
    periodDraw: '제{0}회',
    currentRemain: '현재 {0},残り {1}',
    dragonTiger: '1-5 드래곤/타이거',
    championSum: '챔피언 합계',
    betNow: '지금 베팅',
    tabHistory: '이력',
    tabRoad: '로드 분석',
    tabHotCold: '핫/콜드',
    tabTrend: '챔피언 트렌드',
    rulesTitle: '규칙',
    rule1Title: '드래곤/타이거',
    rule1Desc: '처음과 마지막 추첨 번호를 비교. 처음이 드래곤, 마지막이 타이거.',
    rule2Title: '챔피언 합계',
    rule2Desc: '챔피언과 준우승 번호를 합산하여 합계로 대/소와 홀/짝을 판정.',
    rule3Title: '대/소 홀/짝',
    rule3Desc: '위치 또는 합계에 따라 대(6-10)/소(1-5)와 홀/짝을 판정.',
    rule4Title: '로드 분석',
    rule4Desc: '이력 로드맵 차트를 통해 추첨 패턴과 트렌드를 분석.',
    dragon: '드래곤',
    tiger: '타이거',
    big: '대',
    small: '소',
    odd: '홀수',
    even: '짝수',
    countdownMin: '분',
    countdownSec: '초',
    nameSpeedRacing: '스피드 레이싱',
    nameSgAirship: 'SG 비행선',
    nameSpeedAirship: '스피드 비행선',
    nameLuckyAirship: '럭키 비행선',
    logoRacing: '레이싱',
    logoAirship: '비행선'
  },
  apiDocs: {
    pageTitle: 'API 문서',
    pageSubtitle: 'SMS, 복권 추첨, 고객 서비스 등 API 인터페이스를 신속하게 통합',
    tabSms: 'SMS API',
    tabLottery: '복권 API',
    tabChat: '실시간 채팅 API',
    versionLegacy: '레거시 API',
    versionV2: 'API 2.0',
    versionMini: 'Mini API',
    baseAddress: '기본 URL',
    requestMethod: '메서드',
    returnFormat: '응답 형식',
    authMethod: '인증',
    requestParams: '요청 파라미터',
    field: '필드',
    type: '유형',
    required: '필수',
    description: '설명',
    yes: '예',
    no: '아니오',
    returnExample: '응답 예시',
    smsDesc: 'SMS API는 가상 번호 취득, SMS 수신, 상태 관리의 완전한 기능을 제공하며 200개 이상 국가를 지원합니다.',
    lotteryDesc: '복권 API는 실시간 추첨 데이터 쿼리, 이력, 트렌드 분석을 제공하며 여러 복권 유형을 지원합니다.',
    chatDesc: '실시간 채팅 API는 세션 관리, 메시징, 에이전트 관리를 제공하며 WebSocket 실시간 통신과 RESTful 인터페이스를 지원합니다.',
    ep: {
      getBalance: '잔액 조회', getNumber: '번호 받기', getSms: 'SMS 받기',
      checkBalance: '잔액 확인', createOrder: '주문 생성', querySms: 'SMS 쿼리',
      setStatus: '상태 설정', getCountries: '국가 조회', getServices: '서비스 조회',
      getLotteryList: '추첨 목록 조회', getLotteryHistory: '추첨 이력 조회',
      getLotteryTypes: '복권 유형 조회', liveDraw: '라이브 추첨',
      lotteryHistory: '추첨 이력', lotteryStats: '추첨 통계',
      latestDraw: '최신 추첨', createSession: '세션 생성',
      sendMessage: '메시지 전송', getMessageHistory: '메시지 이력 조회',
      agentStatus: '에이전트 상태', closeSession: '세션 종료', quickSend: '빠른 전송'
    },
    epd: {
      getBalance: '현재 계정 잔액 조회', getNumber: 'SMS 수신을 위한 가상 번호 받기',
      getSms: '번호의 SMS 인증 코드 받기', checkBalance: '현재 사용 가능 잔액 조회',
      createOrder: 'SMS 주문을 생성하고 가상 번호 받기', querySms: '폴링하여 주문 SMS 내용 받기',
      setStatus: '주문 상태 설정 (수신/취소/계속)',
      getCountries: '지원되는 모든 국가 조회', getServices: '지원되는 모든 SMS 서비스 조회',
      getLotteryList: '모든 복권의 최신 추첨 정보 조회', getLotteryHistory: '복권 유형의 추첨 이력 조회',
      getLotteryTypes: '지원되는 모든 복권 유형 조회', liveDraw: '복권의 최신 추첨 결과 조회',
      lotteryHistory: '페이지네이션을 포함한 추첨 이력 조회', lotteryStats: '추첨 통계 조회 (핫/콜드 번호, 결번 값)',
      latestDraw: '모든 복권의 최신 추첨 조회 (간략 버전)', createSession: '새 지원 세션 생성',
      sendMessage: '세션에 메시지 전송', getMessageHistory: '세션의 채팅 이력 조회',
      agentStatus: '온라인 에이전트 목록과 상태 조회', closeSession: '특정 세션 종료',
      quickSend: '세션 생성과 메시지 전송을 한 번에 실행',
      getNumberSimple: '원클릭으로 번호 받기 (간략 버전)', getSmsSimple: 'SMS 내용 받기',
      createSessionV2: '자동 에이전트 할당으로 지원 세션 생성', sendMessageV2: '특정 세션에 메시지 전송'
    }
  },
  liveChat: {
    heroTitle: '실시간 채팅 시스템',
    heroDesc: 'WebSocket 기반의 실시간 고객 서비스 채팅 플랫폼. 다중 에이전트 협업, 스마트 라우팅, 메시지 이력, 파일 전송을 지원하며 고객에게 24시간 연중무휴 즉각적인 서비스를 제공합니다.',
    btnFreeTrial: '무료 체험',
	catedengl: '고객센터 로그인',
    btnDemo: 'PC 클라이언트 다운로드',
    previewName: '왕 에이전트',
    previewStatus: '● 온라인',
    previewMsg1: '안녕하세요! 무엇을 도와드릴까요?',
    previewMsg2: '서비스에 대해 알고 싶습니다',
    previewMsg3: '물론입니다, 소개해 드리겠습니다...',
    inputPlaceholder: '메시지 입력...',
    featuresTitle: '핵심 기능',
    featuresSubtitle: '만족도를 높이는 종합적인 고객 서비스 솔루션',
    feature1Title: '실시간 메시징',
    feature1Desc: 'WebSocket 기반의 밀리초 단위 메시지 전달로 원활한 대화',
    feature2Title: '다중 에이전트 협업',
    feature2Desc: '여러 에이전트가 동시에 온라인, 스마트 세션 라우팅',
    feature3Title: '메시지 이력',
    feature3Desc: '완전한 채팅 이력으로 검색 및 내보내기 가능, 교육 및 참고용',
    feature4Title: '파일 전송',
    feature4Desc: '이미지, 문서 등 파일 유형을 송수신',
    feature5Title: '스마트 라우팅',
    feature5Desc: '에이전트 부하와 스킬 태그를 기반으로 고객을 자동 할당',
    feature6Title: '분석 및 리포트',
    feature6Desc: '세션, 응답 시간, 만족도 등의 실시간 통계',
    stepsTitle: '빠른 설정',
    step1Title: '계정 가입',
    step1Desc: '관리자 계정을 만들고 회사 정보와 지원 팀을 설정',
    step2Title: '코드 삽입',
    step2Desc: '웹사이트에 한 줄의 코드를 삽입하여 채팅 위젯 표시',
    step3Title: '서비스 시작',
    step3Desc: '에이전트가 로그인하여 고객 수신 및 응답 시작',
    dashboardTitle: '강력한 관리 패널',
    dashboardDesc: '에이전트 상태, 세션 데이터, 고객 만족도를 실시간으로 모니터링',
    dashFeature1: '실시간 에이전트 상태 및 세션 수',
    dashFeature2: '세션 라우팅 규칙 및 자동 할당',
    dashFeature3: '에이전트 근무 시간 및 성과 통계',
    dashFeature4: '고객 만족도 평가 및 피드백',
    dashFeature5: '채팅 이력 검색 및 내보내기',
    dashFeature6: '커스텀 빠른 응답 및 지식 베이스',
    dashStat1: '오늘의 세션',
    dashStat2: '만족도',
    dashStat3: '평균 응답',
    dashStat4: '온라인 에이전트',
    pricingTitle: '요금 플랜',
    pricingBadge: '추천',
    pricingPeriod: '/월',
    btnSelectPlan: '플랜 선택',
    planBasic: '베이직',
    planPro: '프로페셔널',
    planEnterprise: '엔터프라이즈',
    ctaTitle: '고객 서비스를 개선할 준비가 되셨나요?',
    ctaDesc: '지금 가입하고 모든 기능을 무료로 체험하세요',
    ctaBtn: '무료로 시작',
    pf1Basic: '1 에이전트', pf2Realtime: '실시간 채팅', pf3History: '메시지 이력',
    pf4Reports: '기본 리포트', pf5Email: '이메일 지원',
    pf1Agents: '10 에이전트', pf4AdvReports: '고급 리포트', pf5Smart: '스마트 라우팅',
    pf6File: '파일 전송', pf7Priority: '우선 지원',
    ef1Unlimited: '무제한 에이전트', ef2All: '모든 기능', ef3Api: 'API 접근',
    ef4Private: '프라이빗 배포', ef5Dedicated: '전용 지원', ef6Sla: 'SLA 보장'
  },
  apiMsg: {
    userNotFound: '등록되지 않은 이메일입니다', wrongPassword: '비밀번호가 올바르지 않습니다', accountDisabled: '이 계정은 비활성화되었습니다',
    agentNotFound: '상담원 계정이 존재하지 않습니다', agentDisabled: '이 상담원 계정은 비활성화되었습니다',
    notLogin: '먼저 로그인해 주세요', tokenExpired: '로그인이 만료되었습니다. 다시 로그인해 주세요',
    emailRequired: '이메일을 입력해 주세요', emailInvalid: '이메일 형식이 올바르지 않습니다',
    emailPasswordRequired: '이메일과 비밀번호를 입력해 주세요', accountPasswordRequired: '계정과 비밀번호를 입력해 주세요',
    agentAccountRequired: '상담원 계정과 비밀번호를 입력해 주세요',
    passwordMin: '비밀번호는 6자 이상이어야 합니다', newPasswordMin: '새 비밀번호는 6자 이상이어야 합니다',
    emailExists: '이미 등록된 이메일입니다', usernameExists: '이미 사용 중인 사용자 이름입니다',
    captchaWrong: '인증 코드가 올바르지 않습니다', captchaExpired: '인증 코드가 만료되었습니다. 다시 받아 주세요',
    paramError: '파라미터가 올바르지 않습니다', paramIncomplete: '모든 항목을 입력해 주세요', missingId: 'ID 가 없습니다',
    nothingToUpdate: '업데이트할 내용이 없습니다', invalidStatus: '상태 값이 올바르지 않습니다', indexOutOfRange: '인덱스가 범위를 벗어났습니다',
    missingChannelCode: '채널 코드가 없습니다', channelNotFound: '채널을 찾을 수 없습니다', channelClosed: '이 채널은 종료되었습니다',
    noChatChannel: '이 회원은 상담 채널을 개설하지 않았습니다', chatPlanExpired: '상담 요금제가 만료되어 사용할 수 없습니다',
    noAgentOnlineRetry: '현재 온라인인 상담원이 없습니다. 잠시 후 다시 시도해 주세요',
    targetAgentInvalid: '대상 상담원이 존재하지 않거나 비활성화되었습니다', agentNoOperate: '상담원이 존재하지 않거나 처리 권한이 없습니다',
    sessionNotFound: '상담을 찾을 수 없습니다', sessionMismatch: '상담 정보가 일치하지 않습니다',
    noPermissionTransfer: '이 상담을 전달할 권한이 없습니다', noPermissionClose: '이 상담을 종료할 권한이 없습니다',
    noPermissionDelete: '이 상담을 삭제할 권한이 없습니다',
    chatHasHistory: '상담 기록이 있어 삭제할 수 없습니다', clientOnline: '고객이 온라인 상태이므로 삭제할 수 없습니다',
    onlyAgentRecall: '상담원이 보낸 메시지만 취소할 수 있습니다',
    balanceInsufficient: '잔액이 부족합니다', rechargeMinAmount: '최소 충전 금액은 1달러입니다',
    orderNotFound: '주문을 찾을 수 없습니다', orderCancelled: '이미 취소된 주문입니다', orderConfirmed: '이미 입금 확인된 주문입니다',
    orderNotPayable: '현재 주문 상태에서는 이 작업을 할 수 없습니다',
    planNotFound: '요금제를 찾을 수 없습니다', serviceNotFound: '서비스를 찾을 수 없습니다', articleNotFound: '글을 찾을 수 없습니다',
    numberUnavailable: '이 번호는 사용할 수 없습니다', noAvailableNumber: '사용 가능한 번호가 없습니다',
    numberExists: '이미 등록된 번호입니다', rentalNotFound: '대여 기록을 찾을 수 없습니다',
    agentLimitReached: '요금제의 상담원 수 한도에 도달했습니다', emailSendFailed: '메일 발송에 실패했습니다. 잠시 후 다시 시도해 주세요'
  },
  clientDownload: {
    badge: '공식 데스크톱 클라이언트',
    heroTitle: '고객 상담 클라이언트 다운로드',
    heroDesc: '상담원을 위해 만든 데스크톱 클라이언트입니다. 여러 상담을 동시에 처리하고, 실시간 알림, 빠른 답변, 상담원 간 전달 기능으로 모든 고객에게 효율적으로 대응할 수 있습니다.',
    winDownload: 'Windows 버전 다운로드',
    winHint: 'Windows 10 / 11',
    macDownload: 'macOS 버전 다운로드',
    macHint: 'macOS 10.15 이상',
    previewAlt: '고객 상담 클라이언트 화면 미리보기',
    notice: '다운로드 후 압축을 풀면 바로 실행되며 설치가 필요하지 않습니다. 개발자를 확인할 수 없다는 경고가 표시되면 시스템 설정에서 실행을 허용해 주세요.',
    featuresTitle: '주요 기능',
    featuresSubtitle: '상담량이 많은 환경을 위한 데스크톱 도구로, 웹 버전보다 안정적이고 빠릅니다',
    f1Title: '다중 상담 관리',
    f1Desc: '왼쪽 상담 목록이 실시간으로 갱신되고 읽지 않은 메시지가 강조되어 여러 고객을 동시에 응대해도 놓치지 않습니다.',
    f2Title: '실시간 메시지 알림',
    f2Desc: 'WebSocket 상시 연결을 통해 방문자 메시지를 밀리초 단위로 받고, 연결이 끊기면 자동으로 재연결합니다.',
    f3Title: '빠른 답변',
    f3Desc: '자주 쓰는 문구를 한 번의 클릭으로 전송해 입력 시간을 줄이고 응답 속도를 높입니다.',
    f4Title: '전달 및 협업',
    f4Desc: '상담을 다른 상담원에게 전달해 복잡한 문제를 팀 단위로 해결할 수 있습니다.',
    stepsTitle: '세 단계로 시작',
    s1Title: '다운로드 및 압축 해제',
    s1Desc: '사용 중인 시스템에 맞춰 Windows 또는 macOS 버전을 선택하고 압축을 풀어 실행합니다.',
    s2Title: '상담원 계정으로 로그인',
    s2Desc: '회원 센터에서 만든 상담 계정으로 로그인하면 소속 채널의 상담이 자동으로 동기화됩니다.',
    s3Title: '상담 시작',
    s3Desc: '방문자 메시지가 실시간으로 도착하며, 빠른 답변과 전달 기능으로 효율적으로 응대할 수 있습니다.',
    ctaTitle: '아직 상담 계정이 없으신가요?',
    ctaDesc: '회원 센터에서 상담원 계정을 만들고 바로 상담을 시작하세요.',
    ctaBtn: '회원 센터로 이동'
  },
  visitorChat: {
    noAgentOnline: '현재 온라인 상담원이 없습니다. 상담원이 온라인이 되면 보내신 메시지에 회신해 드립니다.',
    online: '온라인',
    offline: '오프라인',
    connecting: '연결 중...',
    defaultTitle: '온라인 고객 서비스',
    defaultWelcome: '안녕하세요! 온라인 고객 서비스에 오신 것을 환영합니다. 무엇을 도와드릴까요?',
    channelNotFound: '채널이 존재하지 않거나 종료되었습니다',
    loadError: '로드에 실패했습니다. 잠시 후 다시 시도해주세요',
    imageTooLarge: '이미지 크기는 2MB를 초과할 수 없습니다',
    sendImage: '이미지 보내기',
    inputPlaceholder: '메시지를 입력하세요...',
    supportSuffix: '의 고객 서비스'
  }
}
